import React from "react";

const anjali_phule = () => {
  return (
    <div>
      <h1>Anjali Phule</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>CSI Internship Diaries 2025</strong>
      </p>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The minimum CGPA criteria was 7.5, and candidates should have no
        backlogs.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        There were no interviews. The selection process consisted of an aptitude
        round followed by a 12-hour hackathon.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round was an online test consisting of 2 hard DSA problems
        to be solved in 1 hour. I solved the first question completely and
        managed to pass all its test cases, and for the second question, I
        passed 2 test cases.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        11 students were shortlisted.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        There was no interview. The shortlisted students had a meeting with
        their mentor 5 days before the hackathon. During this period, I focused
        on MERN stack, revising both frontend and backend concepts.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        After the aptitude test, 11 students were shortlisted. The next stage
        was a 12-hour hackathon, where each team had 8 members. The hackathon
        involved ideation, project development, and presentation. After the
        hackathon, 8 students were offered the internship.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        Since there were no interviews, the focus was on the hackathon project.
        Mentors and judges asked questions about the tech stack used (MongoDB,
        SQL), implementation details, and project decisions. It was important to
        take the lead, discuss ideas with mentors and team members, implement
        them efficiently, seek feedback, and have good presentation skills.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        For Mastercard: Chai aur Code YouTube channel
        <br />
        General preparation:
        <br />
        DSA: Striver Sheet
        <br />
        OOPD: Love Babbar One-Shot and GeeksforGeeks notes
        <br />
        Aptitude: IndiaBix
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Solve the A2Z Striver Sheet daily and consistently cover new DSA
        concepts.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        No questions were asked about projects, clubs, or extracurriculars.
        However, questions were asked about the tech stack used in the hackathon
        project.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Take the lead, always share your ideas with mentors, and don’t panic
        during the hackathon.
        <br />
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Start preparing for the internship process as early as possible. Solve
        daily DSA questions and focus on building strong web development skills.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:anjaliphule5@gmail.com">anjaliphule5@gmail.com</a>
      </p>
    </div>
  );
};

export default anjali_phule;
